module.exports = __webpack_public_path__ + "img/corner-information-outline.a5756a91.svg";